import moment from "moment";
import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import DataTable from "react-data-table-component-with-filter";
import { Tooltip } from "react-tooltip";
import {
  LINEHAUL_CUSTOMER_BUSINESS_PARTNERS,
  PARTIAL_PAY_INV_STAT_ID,
  UNPAID_INV_STAT_ID,
} from "../../ConfigConstants/ConfigConstants";
import GetSvgIcon from "../../images/svglist";
import {
  DATE_FORMAT_MOMENT,
  DATE_TIME_FORMAT_MOMENT,
  customDataTableStyles,
  defaultPageLimit,
  defaultRowsPerPageOptions,
} from "../Helper/Constants";
import { CallApiGet } from "../Helper/serviceApi";
import InvoiceDetails from "./InvoiceDetails";

export const custConditionalStyle = [
  {
    when: (row) => row.invoiceAmount === row.paymentAmount,
    style: {
      color: "#43cb43",
      fontWeight: 500,
    },
  },
  {
    when: (row) => row.invoiceAmount !== row.paymentAmount,
    style: {
      color: "red",
      fontWeight: 500,
    },
  },
];

export const custConditionalStyle2 = [
  {
    when: (row) => row.stat_id === 100,
    style: {
      color: "#43cb43",
      fontWeight: 500,
    },
  },
  {
    when: (row) => row.stat_id === 178,
    style: {
      color: "red",
      fontWeight: 500,
    },
  },
  {
    when: (row) => row.stat_id === 710 || row.stat_id === 711,
    style: {
      color: "#964b00",
      fontWeight: 500,
    },
  },
  {
    when: (row) => row.stat_id === 101,
    style: {
      color: "#FF7518",
      fontWeight: 700,
    },
  },
];

export const custConditionalStyle3 = [
  {
    when: (row) => row.stat_id === 101,
    style: {
      color: "#FF7518",
      fontWeight: 700,
    },
  },
  {
    when: (row) => row.stat_id === 178,
    style: {
      color: "red",
      fontWeight: 400,
    },
  },
  {
    when: (row) => row.stat_id === 100,
    style: {
      color: "green",
      fontWeight: 400,
    },
  },
];

export const invColumns = [
  {
    name: "Trans Date",
    selector: (row) => moment(row.trans_date).format(DATE_FORMAT_MOMENT),
    // selector: (row) => new Date(row.trans_date),
    cell: (row) => moment(row.trans_date).format(DATE_TIME_FORMAT_MOMENT),
    // sortable: true,
    filterable: true,
    // omit: hideColums,
    // sortType: (a, b) => {
    //   return new Date(b.values.trans_date) - new Date(a.values.trans_date);
    // },
  },
  {
    name: "Inv/Payment No",
    selector: (row) => row.ref_no,
    sortable: true,
    filterable: true,
    // omit: hideColums,
    cell: (row) => (
      <>
        <div>
          {row.ref_no}
          {!!row.ref_no && row.ref_no.includes("MTR") && (
            <span
              data-tooltip-id={"msg-" + row.ref_no}
              className="mx-2 my-3 theme-violet-txt position-absolute top-0 end-0"
            >
              {GetSvgIcon("ToolTip")}
            </span>
          )}
        </div>
        <Tooltip
          id={"msg-" + row.ref_no}
          content={
            !!row.ref_no && row.ref_no.includes("MTR") ? row.mp_note : ""
          }
          place="right"
          style={{ zIndex: "100" }}
        />
      </>
    ),
  },
  {
    name: "Transaction Detail",
    selector: (row) =>
      row.particulars + (!!row.mp_note ? " (" + row.mp_note + ")" : ""),

    sortable: true,
    filterable: true,
  },
  {
    name: "Status",
    selector: (row) => row.status,
    sortable: true,
    filterable: true,
    conditionalCellStyles: custConditionalStyle3,
    cell: (row) => (
      <>
        <div>
          {row.status}
          {/* {row.stat_id === 101 && (
            <span
              data-tooltip-id={"msg2-" + row.ref_no}
              className="mx-2 my-3 theme-violet-txt position-absolute top-0 end-0"
            >
              {GetSvgIcon("ToolTip")}
            </span>
          )} */}
        </div>
        <Tooltip
          id={"msg2-" + row.ref_no}
          content={
            <Card style={{ opacity: 1 }}>
              <Card.Title>You have RM {row.un_paid_amt} to Pay</Card.Title>
            </Card>
          }
          place="right"
          style={{ zIndex: "100" }}
        />
      </>
    ),
  },
  {
    name: "Debit",
    filterable: true,
    selector: (row) => row.dr_amt.toFixed(2),
    conditionalCellStyles: custConditionalStyle2,
    cell: (row) => (
      <>
        <div>
          {row.dr_amt.toFixed(2) + " "}
          {row.un_paid_amt > 0 && row.stat_id === 101 && (
            <span className="theme-violet-txt" style={{ fontWeight: "normal" }}>
              (You have RM {row.un_paid_amt} to Pay)
            </span>
          )}
        </div>
      </>
    ),
  },
  {
    name: "Credit",
    selector: (row) => row.cr_amt.toFixed(2),
    filterable: true,
    conditionalCellStyles: custConditionalStyle,
  },
];

export default function InvoiceList(props) {
  const {
    invoiceDataList,
    paymentStatusBtn,
    setInvoiceDistributionList,
    setTotalaBillAmount,
    customerDtls,
    fetchAllInvoiceList,
    unBilledInvArr,
    dnCnList,
    setSpinner,
    latestInvAmt,
    cnAmt,
    openCustCn,
    avlCreditLimit,
    clearSelectedRows,
    statusType,
    filterData,
    avlAdvanceLimit,
    openCustAdv,
  } = props;

  useEffect(() => {
    // const permissionVal = permissionCheck(INVS, "allowedRead")?.allowedRead;
    // setHideColums(permissionVal ? false : true);
  }, []);
  const lcInvColumns = [
    ...invColumns,
    {
      name: "",
      cell: (row) =>
        row.inv_id > 0 ? (
          // && !row?.ref_no?.includes("-DN-")
          <>
            <div
              data-tooltip-id={"inv-" + row?.ref_no + row?.trans_date}
              className="me-3"
              onClick={() => invoiceDownload(row)}
            >
              {GetSvgIcon("IconFiledownload")}
            </div>
            <Tooltip
              id={"inv-" + row.ref_no}
              content="Download Invoice"
              place="left"
            />
          </>
        ) : (
          ""
        ),
      allowOverflow: true,
      button: true,
      width: "56px",
    },
  ];

  /**
   * The function `invoiceDownload` generates and downloads an invoice PDF based on the provided order
   * data.
   * @param orderData - The `orderData` parameter is an object that contains information about an order.
   * It likely includes properties such as `invoiceNo` (the invoice number) and `customerType` (the type
   * of customer, which can be either "CREDIT" or something else).
   */
  const invoiceDownload = async (orderData) => {
    props.setSpinner(true);
    let custType = LINEHAUL_CUSTOMER_BUSINESS_PARTNERS.includes(
      String(orderData.cust_type)
    )
      ? true
      : false;
    if (
      orderData.ref_no.includes("-II-") ||
      orderData.ref_no.includes("-DN-")
    ) {
      custType = false;
    }
    const response = await CallApiGet(
      `generateAllInvoicePdf/${orderData.ref_no}/${custType}`
    );
    setSpinner(false);
    if (response.respCode === 200) {
      window.open(response.respData, "_blank");
    }
  };

  /**
   * The function `selectInvoice` takes an array of selected rows, calculates the total amount for each
   * row, updates the invoice distribution list, and calculates the total bill amount.
   */
  const selectInvoice = ({ selectedRows }) => {
    let dataList = [];
    selectedRows.forEach((v, i) => {
      dataList.push({
        invoiceId: v.inv_id,
        invoiceAmount: v.un_paid_amt,
        invoiceNo: v.ref_no,
      });
    });
    setInvoiceDistributionList(dataList);
    let totalAmount = 0.0;
    dataList.forEach((v, k) => {
      totalAmount = totalAmount + v.invoiceAmount;
    });
    setTotalaBillAmount(totalAmount);
  };
  const rowDisabledCriteria = (row) =>
    ![UNPAID_INV_STAT_ID, PARTIAL_PAY_INV_STAT_ID].includes(row.stat_id);
  return (
    <>
      {/* {paymentStatusBtn ? <InvoiceDetails customerDtls={customerDtls} /> : ""} */}
      <InvoiceDetails
        customerDtls={customerDtls}
        fetchAllInvoiceList={fetchAllInvoiceList}
        unBilledInvArr={unBilledInvArr}
        dnCnList={dnCnList}
        latestInvAmt={latestInvAmt}
        cnAmt={cnAmt}
        openCustCn={openCustCn}
        avlCreditLimit={avlCreditLimit}
        avlAdvanceLimit={avlAdvanceLimit}
        openCustAdv={openCustAdv}
      />
      <nav className="pt-1">
        <div className="nav nav-tabs">
          <button
            type="button"
            className={statusType === "all" ? "nav-link active" : "nav-link"}
            onClick={() => filterData("all")}
          >
            ALL
          </button>
          <button
            type="button"
            className={statusType === "unpaid" ? "nav-link active" : "nav-link"}
            onClick={() => filterData("unpaid")}
          >
            Un-Paid
          </button>
          {/* <button
            type="button"
            className={statusType === "paid" ? "nav-link active" : "nav-link"}
            onClick={() => filterData("paid")}
          >
            Paid
          </button> */}
          <button
            type="button"
            className={
              statusType === "inprogress" ? "nav-link active" : "nav-link"
            }
            onClick={() => filterData("inprogress")}
          >
            Inprogress
          </button>

          {/* {permissionCheck(FTL, "allowedRead") && (
                      <button
                        className={
                          statusType === "FTL" ? "nav-link active" : "nav-link"
                        }
                        onClick={() => filterData("FTL")}
                      >
                        Full Truck ({orderListCount.ftl})
                      </button>
                    )} */}
        </div>
      </nav>
      <div className="col-md-12 table-responsive customized-data-table position-relative popup-data-table">
        <DataTable
          columns={lcInvColumns}
          data={invoiceDataList}
          customStyles={customDataTableStyles}
          selectableRows={paymentStatusBtn}
          onSelectedRowsChange={selectInvoice}
          selectableRowDisabled={rowDisabledCriteria}
          clearSelectedRows={clearSelectedRows}
          pagination
          striped
          highlightOnHover
          paginationRowsPerPageOptions={defaultRowsPerPageOptions}
          paginationPerPage={defaultPageLimit}
        />
      </div>
    </>
  );
}
